import { EnvironmentService } from './environment.service';
import { UploadService } from './upload.service';
import { ValidationService } from './validation.service';

export const services: any[] = [EnvironmentService, UploadService, ValidationService];

export * from './environment.service';
export * from './upload.service';
export * from './validation.service';
